<a
  id="btn-scroll-top"
  [ngClass]="{ 'show-scroll-top': windowScrolled }"
  (click)="scrollToTop()"
>
  <fa-icon [icon]="faAngleUp"></fa-icon>
</a>
